<template>
  <div class="iOSCourse">
    <div class="cs-iosCou-part1">
      <div class="container">
        <div class="item-1">
          <h1>iOS 课程</h1>
          <!-- <h2>AATP 介绍</h2> -->
          <p class="p1">AATP（Apple Authorized Training Provider）</p>
          <p class="p2">Apple 和 RTP 是专门针对高职院校的教学需求，对接岗位所需所开发出的适合职业教育的课程体系。</p>
        </div>
        
        <div class="item-2">
          <img src="../assets/img/icon-iosC-1.png" alt="">
          <h1>iOS 开发类课程</h1>
          <p class="p1">软件技术专业<br> iOS 开发方向</p>
          <p class="p2">主要内容</p>
          <p class="p3">语言(基本数据类型、运算符、字符串)、 Swift 语言(函数、Closures)、Swift 语言(类、结构体、属性)、Swift 语言(初始化、接口、访问控制)、Swift 和 Object-C 混合编程 </p>
        </div>

        <div class="item-3">
          <el-row :gutter="60">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <div class="item-box">
                <img src="../assets/img/icon-iosC-2.png" alt="">
                <p class="p1">IT 支持类课程</p>
                <p class="p2">计算机应用专业<br>IT 服务与管理方向</p>
                <p class="p3">主要内容</p>
                <p class="p4">升级并重新安装 macOS Mojave<br>设置和配置 macOS<br>命令行界面和 macOS 恢复<br>管理用户帐户和用户个人文件夹<br>macOS 安全性功能和密码更改<br></p>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <div class="item-box">
                <img src="../assets/img/icon-iosC-3.png" alt="">
                <p class="p1">数字媒体类课程</p>
                <p class="p2">数字媒体应用技术专业<br>网络媒体与影视后期方向</p>
                <p class="p3">主要内容</p>
                <p class="p4">了解Final Cut Pro的基本工作流程<br>片段、事件和媒体资源库的定义<br>了解内部媒体文件和外部媒体文件之间的区别<br>创建相机存档</p>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="item-4">
          <p>AATP 认证考试</p>
          <h1>教学实训考试一体化平台</h1>
        </div>

        <div class="item-5">
          <!-- 1,,,2 -->
          <el-row :gutter="60">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <div class="item-box">
                <div class="item-box-l">
                  <div class="middle"><img src="../assets/img/icon-iosC-4.png" alt=""></div>
                </div>
                <div class="item-box-r">
                  <p class="tit">iOS 应用开发课程 </p>
                  <p class="con">加入微课、丰富教学资源，SaaS 部署方式，定制更新。</p>
                  <p class="tag" style="color: #00ABEF;">教学系统</p>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <div class="item-box">
                <div class="item-box-l">
                  <div class="middle"><img src="../assets/img/icon-iosC-5.png" alt=""></div>
                </div>
                <div class="item-box-r">
                  <p class="tit">案例实训项目</p>
                  <p class="con">真实大厂案例实训，快速积累实操经验。</p>
                  <p class="tag" style="color: #A96CD7;">实训系统</p>
                </div>
              </div>
            </el-col>
          </el-row>

          <!-- 3,,,4 -->
          <el-row :gutter="60">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <div class="item-box">
                <div class="item-box-l">
                  <div class="middle"><img src="../assets/img/icon-iosC-6.png" alt=""></div>
                </div>
                <div class="item-box-r">
                  <p class="tit">认证考试</p>
                  <p class="con">iOS 应用开发新工科认证考试平台。</p>
                  <p class="tag" style="color: #00C7A9;">考试系统</p>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <div class="item-box">
                <div class="item-box-l">
                  <div class="middle"><img src="../assets/img/icon-iosC-7.png" alt=""></div>
                </div>
                <div class="item-box-r">
                  <p class="tit">实习推荐</p>
                  <p class="con">就业推荐，实习信息实时发布。</p>
                  <p class="tag" style="color: #FA243C;">实习发布系统</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="cs-iosCou-part2">
      <div class="container">
        <h1>基于课程的整体方案丰富现有课程体系</h1>
        <div class="item-box">
          <!-- 1 -->
          <div class="item">
            <div class="item-l">
              <p>3类创新课</p>
            </div>
            <div class="item-r">
              <p class="p1">课程名称</p>
              <p class="p2">《iOS 应用开发基础课程》</p>
              <p class="p2">《iOS 应用开发游戏开发课程》</p>
              <p class="p2">《iOS 应用开发 AI&AR 课程》</p>
              <p class="p2">《Final Cut Pro X 视频剪辑》</p>
              <p class="p2">《macOS 操作系统从入门到精通》</p>
            </div>
            <div style="clear:both"></div>
          </div>
          <!-- 2 -->
          <div class="item">
            <div class="item-l">
              <p>师资培养</p>
            </div>
            <div class="item-r">
              <el-row>
                <el-col :span="10"><p class="p1" style="margin-right:70px">教学实训认证平台</p></el-col>
                <el-col :span="14"><p class="p1" style="margin-lrgt:70px">教学实训认证平台</p></el-col>
              </el-row>
            </div>
            <div style="clear:both"></div>
          </div>
          <!-- 3 -->
          <div class="item">
            <div class="item-l">
              <div class="middle">
                <p>实训教室</p>
              </div>
            </div>
            <div class="item-r"><img src="../assets/img/icon-iosC-8.png" alt=""></div>
            <div style="clear:both"></div>
          </div>

          <!-- 4 -->
          <div class="item">
            <div class="item-l">
              <div class="middle">
                <p>iOS Club</p>
              </div>
            </div>
            <div class="item-r"><img src="../assets/img/cs-iosC-1.jpg" alt=""></div>
            <div style="clear:both"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="cs-iosCou-part3">
      <div class="container">
        <h1>现有认证资质</h1>
        <el-row :gutter="60" style="margin-bottom: 40px">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12"><div class="item"><img src="../assets/img/cs-iosC-2.jpg" alt=""></div></el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12"><div class="item"><img src="../assets/img/cs-iosC-3.jpg" alt=""></div></el-col>
        </el-row>
        <el-row :gutter="60">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12"><div class="item"><img src="../assets/img/cs-iosC-4.jpg" alt=""></div></el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12"><div class="item"><img src="../assets/img/cs-iosC-5.jpg" alt=""></div></el-col>
        </el-row>
      </div>
    </div>

    <div class="cs-page">
      <router-link to="home" active-class="activeClass">首页</router-link>
      <router-link to="Protrain" active-class="activeClass">上一页</router-link>
      <router-link to="studentClub" active-class="activeClass">下一页</router-link>
    </div>

  </div>
</template>
<script>
export default {
  name:'iOSCourse',
  data() {
    return {
    }
  },
  mounted(){
  },
  methods: {
    
  }
}
</script>
<style lang="scss">
.iOSCourse{
   border-bottom: 1px solid #D6D6D6;
   background: #f5f5f7;
   .cs-iosCou-part1{
     .item-1{
       text-align: center;
       h1{
          font-size: 58px;
          font-weight: 600;
          color: #000000;
          line-height: 76px;
          margin-top: 115px;
       }
       h2{
          font-size: 40px;
          font-weight: 600;
          color: #0071E3;
          line-height: 38px;
          margin: 49px 0 39px 0;
       }
       .p1{
          font-size: 24px;
          font-weight: 600;
          color: #000000;
          line-height: 38px;
          color: #0071E3;
          margin-top: 39px;
       }
       .p2{
          font-size: 20px;
          font-weight: 400;
          color: #000000;
          line-height: 38px;
          margin-bottom: 45px;
          color: #0071E3;
       }
     }
     .item-2{
       text-align: center;
       padding-bottom: 66px;
       background: #fff;
       border-radius: 22px;
       box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
       word-break: break-word;
       img{
         margin: 68px 0 34px 0;
       }
       h1{
          font-size: 32px;
          font-weight: 600;
          color: #000000;
          line-height: 30px;
          margin: 34px 0 24px 0;
       }
       .p1{
          font-size: 22px;
          font-weight: 400;
          color: #0071E3;
          line-height: 36px;
          margin-bottom: 45px;
       }
       .p2,.p3{
          font-size: 24px;
          font-weight: 400;
          color: #000000;
          line-height: 38px;
       }
       .p3{
         font-size: 20px;
         max-width: 957px;
         margin: 0 auto;
         color: #333;
       }
     }
     .item-3{
       margin: 0 0 60px 0;
       .item-box{
         margin-top: 60px;
         padding: 60px 50px 0 83px;
         height: 660px;
         background: #fff;
         border-radius: 22px;
         box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
         .p1{
            font-size: 32px;
            font-weight: 600;
            color: #000000;
            line-height: 30px;
            margin: 38px 0 24px 0;
         }
         .p2{
            font-size: 22px;
            font-weight: 400;
            color: #0071E3;
            line-height: 36px;
            margin-bottom: 35px;
         }
         .p3,.p4{
            font-size: 24px;
            font-weight: 400;
            color: #000000;
            line-height: 38px;
         }
         .p4{
           font-size: 20px;
           color: #333;
         }
       }
     }
     .item-4{
       text-align: center;
       p{
          font-size: 32px;
          font-weight: 600;
          color: #0071E3;
          line-height: 38px;
          margin: 29px 0 36px 0;
       }
       h1{
          font-size: 42px;
          font-weight: 600;
          color: #000000;
          line-height: 38px;
          margin: 36px 0 64px 0;
       }
     }
     .item-5{
       .item-box{
          height: 360px;
          background: #FFFFFF;
          border-radius: 22px;
          padding: 77px 0 77px 0;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          word-break: break-word;
          margin-bottom: 60px;
          .item-box-l{
            width: 20%;
            float: left;
            margin-left: 10%;
            .middle{
              display: table-cell;
              vertical-align: middle;
              height: 240px;
            }
          }
          .item-box-r{
            float: left;
            width: 55%;
            margin-left: 5%;
            // margin-left: 60px;
          }
          .tit{
            font-size: 32px;
            font-weight: 600;
            color: #000000;
            line-height: 30px;
          }
          .con{
            font-size: 24px;
            font-weight: 400;
            color: #000000;
            line-height: 38px;
            margin: 36px 0 48px 0;
          }
          .tag{
            font-size: 30px;
            font-weight: 400;
            line-height: 36px;
          }
       }
     }
   }

   .cs-iosCou-part2{
     background: #fff;
     h1{
        font-size: 42px;
        font-weight: 600;
        color: #000000;
        line-height: 38px;
        line-height: 70px;
        padding: 40px 0;
        text-align: center;
     }
     .item-box{
       .item{
         border-top: 1px solid #D6D6D6;
         padding: 48px 0;
         .item-l,.item-r{
           float: left;
         }
         .item-l{
           width: 35%;
           padding-left: 60px;
           .middle{
             display: table-cell;
             vertical-align: middle;
             height: 195px;
           }
           p{
              font-size: 32px;
              font-weight: 600;
              color: #000000;
              line-height: 30px;
           }
         }
         .item-r{
           width: 65%;
           .p1{
              font-size: 24px;
              font-weight: 600;
              color: #000000;
              line-height: 30px;
           }
           .p2{
              font-size: 20px;
              font-weight: 400;
              color: #000000;
              line-height: 45px;
           }
           img{
             max-width: 100%;
           }
         }
       }
     }
   }

   .cs-iosCou-part3{
     background: #f5f5f7;
     text-align: center;
     h1{
        font-size: 42px;
        font-weight: 600;
        color: #000000;
        line-height: 38px;
        margin: 78px 0 57px 0;
     }
     .item{
        width: 100%;
        img{
          float: left;
          max-width: 100%;
        }
     }
   }
}
// 适配
@media screen and (max-width: 992px) {
  .iOSCourse .cs-iosCou-part2 .item-box .item .item-r .p1{
    margin-right: 0;
  }
}
// 适配
@media screen and (max-width: 768px) {
  .iOSCourse .cs-iosCou-part2 .item-box .item .item-l{
    padding-left: 0;
  }
  .iOSCourse .cs-iosCou-part2 .item-box .item .item-r .p1{
    margin-right: 0!important;
  }
  .iOSCourse .cs-iosCou-part1 .item-5 .item-box .item-box-l .middle{
    img{
      max-width: 75%;
    }
  }
}
</style>
